"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2995],{

/***/ 42995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




const CardIcon = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].span.withConfig({
  componentId: "sc-1wfppxg-0"
})(["& svg{margin:auto;}"]);

const Card = _ref => {
  let {
    title,
    description,
    icon
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    textAlign: "center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardIcon, {
      children: icon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "1.375rem",
      letterSpacing: "0.6px",
      lineHeight: "28.6px",
      whiteSpace: "pre-wrap",
      marginTop: "l",
      marginBottom: "xs",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseDark",
      fontFamily: "Montserrat-Regular",
      fontSize: "1rem",
      letterSpacing: "0.2px",
      lineHeight: "20.8px",
      children: description
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Card);

/***/ })

}]);